import React from "react";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

import { TabsContent } from "../ui/tabs";
import Network from "./tabs/Network";
import Applications from "./tabs/Applications";
import Device from "./tabs/Device";
import Issues from "./tabs/Issues";

const UserTabContent = ({ userId }) => {
  const history = useHistory();

  return (
    <>
      <TabsContent value="network">
        <Network
          userId={userId}
          history={history}
        />
      </TabsContent>

      <TabsContent value="application">
        <Applications
          userId={userId}
          history={history}
        />
      </TabsContent>

      <TabsContent value="device">
        <Device
          userId={userId}
          history={history}
        />
      </TabsContent>

      <TabsContent value="issues">
        <Issues
          userId={userId}
          history={history}
        />
      </TabsContent>
    </>
  );
};

export default UserTabContent;
